export default __webpack_public_path__ + "static/media/InfoIcon.ca1748e9.svg";